import { queryClient } from '@/lib/query-client'
import { useNotificationStore } from '@/store/notification.store'
import { resetDeliveredAcks } from '@/modules/messenger/utils/chat-realtime'

/**
 * Almost every query key in this app (messenger, tasks, sales leads,
 * notifications, dashboard…) is scoped to "whoever is currently signed in"
 * but doesn't carry that user's id in the key itself. Without this, logging
 * out and back in as someone else on the same tab/PWA (no hard reload) lets
 * the next user's first paint read the previous user's cached chats/tasks/
 * leads/unread counts until each query happens to revalidate.
 *
 * Called from auth.store's `clearSession` (logout + 401 + failed refresh)
 * and `login` (before the new session is set) so a user switch never shows
 * so much as a flash of the previous session's data.
 */
export function resetUserScopedClientState(): void {
  queryClient.clear()
  useNotificationStore.getState().reset()
  resetDeliveredAcks()
}
